import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/welcome-page/welcome-page.tsx");
